import { NftItemRarity } from 'src/utils/types';
export const colorMap = {
  [NftItemRarity.COMMON]: {
    displayValue: 'Common',
    color: 'common'
  },
  [NftItemRarity.EPIC]: {
    displayValue: 'Epic',
    color: 'epic'
  },
  [NftItemRarity.LEGENDARY]: {
    displayValue: 'Legendary',
    color: 'legendary'
  }
};